<template>

	<div>
		<v-snackbar class="snackbar" :color="globalSnackColor" :timeout="4000" :right="true" :top="true" :value="globalSnackDisplay">
			{{ globalSnackMessage }}
		</v-snackbar>
		<!--<mo-sidebar></mo-sidebar>-->
        <v-navigation-drawer class="mainMenu" mobile-break-point="10240" clipped fixed hide-overlay v-model="drawer" app style="padding-bottom: 0px !important; overflow-y: scroll !important; ::-webkit-scrollbar: width: 5px !important;">
          <v-list dense>
            <div class="menu_holder">
              <v-list-tile @click="fncGoPage('/')" v-if="objAuthorize.type != 6">
                <v-list-tile-action>
                  <v-icon style="color: yellow">insert_chart</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>Dashboard</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-list-tile @click="fncShowSettings()" v-if="fncCheckSettings()">
                <v-list-tile-action>
                  <v-icon>settings</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>General Settings</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-list-tile @click="fncShowInstallations()" v-if="fncCheckSettings()">
                <v-list-tile-action>
                  <v-icon>gavel</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>Installations</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-list-tile @click="fncShowSetup()" v-if="objAuthorize.email == 'superuser@ndtec.co.za'">
                <v-list-tile-action>
                  <v-icon>build</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>MyOrder Setup</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-list-tile @click="fncGoPage('/tokens/')" v-if="objAuthorize.email == 'superuser@ndtec.co.za'">
                <v-list-tile-action>
                  <v-icon>fingerprint</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>Tokens</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-list-tile @click="fncGoPage('/vendors/')" v-if="objAuthorize.email == 'superuser@ndtec.co.za' || objAuthorize.email == 'bwsuperuser@ndtec.co.za'">
                <v-list-tile-action>
                  <v-icon>receipt</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>Vendor List</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-list-tile @click="fncShowStock()" v-if="objAuthorize.privileges && objAuthorize.type != 6 && objAuthorize.privileges.indexOf('STOCK_AVAILABILITY') !== -1">
                <v-list-tile-action>
                  <v-icon>list</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>Stock Availability</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </div>
            <div v-for="(item, index) in menu" class="menu_holder" :key="item.id">
              <v-list-tile v-if="objAuthorize.privileges && objAuthorize.privileges.indexOf(item.priv) !== -1 || item.priv === 'All'" @click="showNavChildren(item.id, item.link, index)">
                <v-list-tile-action>
                  <v-icon :style="{ color: item.color }">{{ item.icon }}</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-list-tile :id="objAuthorize.privileges.indexOf(subItem.priv_not) != -1" class="navChild" v-if="clickStatus[index][item.id] && ( objAuthorize.privileges.indexOf(subItem.priv) !== -1 || subItem.priv === 'All' )" v-for="(subItem, subIndex) in item.children" :key="subItem.id">
                <v-list-tile-content class="navChilditem">
                  <v-list-tile-title class="cursor" @click="fncGoPage(subItem.link)"><span :style="{ background: item.color }" class="subIcon">{{ showFirstLetter(subItem.title) }}</span>{{ fncSubMenuTitle(subItem.title) }}</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </div>
            <!--<div class="menu_holder">
              <v-list-tile @click="fncClearStorage()">
                <v-list-tile-action>
                  <v-icon>filter_list</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>Clear All Filters</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </div>-->
          </v-list>
        </v-navigation-drawer>
		<v-toolbar class="navbar" dark fixed app>
			<v-flex xs5 class="header-links">
				<v-toolbar-side-icon color="white" @click.stop="toggleDrawer"></v-toolbar-side-icon>
<!--        <span>-->
<!--        <v-btn @click.prevent="fncGoDashboard()" class="pl-2 home-link" icon style="color: rgb(85 85 85 / 92%);width: 60px; font-weight: 700;">-->
<!--          <i class="material-icons">home</i> Home-->
<!--        </v-btn>-->
<!--        <span v-if="showButton == true && objAuthorize.privileges && objAuthorize.privileges.indexOf('VIEW_QUOTES') !== -1" class="pl-2 pr-2" style="color: rgb(85 85 85 / 47%);">|</span>-->
        <v-btn v-if="objAuthorize.privileges && objAuthorize.privileges.indexOf('VIEW_QUOTES') !== -1" @click.prevent="fncGoQuoteReportsLite()" class="pl-0 widget-link" :class="{'active' : isActiveButtonLite}">
          <i class="material-icons" style="display: block !important;">bolt</i> Quotes Bolt
        </v-btn>
<!--        <span v-if="objAuthorize.privileges.indexOf('VIEW_WIDGETS') !== -1 " class="pl-2 pr-2" style="color: rgb(85 85 85 / 47%);">|</span>-->
        <v-btn v-if="objAuthorize.privileges.indexOf('VIEW_WIDGETS') !== -1 " @click.prevent="fncGoWidgets()" class="pl-0 widget-link" :class="{'active' : ShowWidgets}">
          <i class="material-icons">timeline</i> Widgets
        </v-btn>
<!--        <span v-if="objAuthorize.privileges.indexOf('CAN_SUMMARY_REPORTING') !== -1 " class="pl-2 pr-2" style="color: rgb(85 85 85 / 47%);padding-left: 10px !important">|</span>-->
        <v-btn v-if="objAuthorize.privileges.indexOf('CAN_SUMMARY_REPORTING') !== -1" @click.prevent="fncGoSummary()" class="pl-0 widget-link">
          <i class="material-icons">summarize</i> Summary Reports
        </v-btn>
        <!--<v-btn v-if="objAuthorize.manufacturer != '16777962' && objAuthorize.privileges && objAuthorize.privileges.indexOf('VIEW_QUOTES') !== -1"   @click.prevent="fncGoQuoteReports()" class="pl-0 quote-link" :class="{'active' : isActiveButton}">-->
          <v-btn v-if="objAuthorize.manufacturer == '385889803' && objAuthorize.privileges && objAuthorize.privileges.indexOf('VIEW_QUOTES') !== -1"   @click.prevent="fncGoQuoteReports()" class="pl-0 quote-link" :class="{'active' : isActiveButton}">
          <i class="material-icons">bubble_chart</i> Quotes (Previous Version )
        </v-btn>
<!--        <v-btn icon style="color: black">-->
<!--          <v-icon>mdi-accountTree</v-icon>-->
<!--        </v-btn>--> 
<!--          </span>-->
<!--        <v-btn class="pl-4" style="color: #555555" icon>-->
<!--          <i class="material-icons">home</i> Home <span>|</span>-->
<!--        </v-btn>-->
<!--        <v-btn class="pl-4" style="color: #555555" icon>-->
<!--          <i class="material-icons">merge</i> Quote Pipeline <span>|</span>-->
<!--        </v-btn>-->
<!--        <i aria-hidden="true" class="icon material-icons">home</i> Home |-->
<!--				<v-btn v-if="objAuthorize.privileges && objAuthorize.privileges.indexOf('VIEW_QUOTES') !== -1 && showButton == true" @click.prevent="fncGoQuoteReports()" class="elevation-5" color="info">View Quotes Report</v-btn>-->
        <!--<v-btn v-if="objAuthorize.privileges.indexOf('VIEW_QUOTES') !== -1 && showDashboard == true" @click.prevent="fncGoDashboard()" class="elevation-5" color="info">View Dashboard</v-btn>-->
<!--        <v-btn v-if="objAuthorize.privileges.indexOf('VIEW_WIDGETS') !== -1" @click.prevent="fncGoWidgets()" class="elevation-5" color="info">View Widget Report</v-btn>-->
			</v-flex>
<!--          <v-flex xs2 clientlogo>-->
<!--            <img :src="fncGetLogo()" height="50" />-->
<!--            </v-flex>-->
          <v-flex xs2 class="cmsLogo">
            &nbsp;
            <!--<h4 style="padding-left: 10px;padding-top: 0px !important;display:block;width:100%;"><center>{{ userManufacturer }}</center></h4>-->
          </v-flex>
          <v-flex xs2 myorderlogo>
            <div >
              <img style="position: absolute;margin: 0px auto;text-align: center;width: auto;display: inherit;right: 180px !important;" :src="fncGetLogo()" height="35" />
            </div>
            <img src="../../assets/logo.png" />
          </v-flex>
            <!--<v-flex xs6 class="cmsLogo">

              <h4 style="padding-left: 10px;padding-top: 18px !important;">{{ userManufacturer }}</h4>
              <img src="../../assets/logo.png" width="125" style="padding-top: 16px !important;" />
            </v-flex>-->
            <v-flex xs3>
              <div class="userDetails">
                <!--<v-avatar size="24px" slot="activator">
            <img src="../shared/assets/images/avatar.png" alt="">
            <v-icon</v-icon>
        </v-avatar>-->
                <p class="loggedUser">{{ userFullname }} | <a href="#" @click.stop="fncLogout">LOGOUT</a></p>
              </div>
            </v-flex>
</v-toolbar>
		<modal></modal>
	</div>

</template>

<script>
    import menu from '@/menu';
    import Vue from 'vue';
    import router from '@/router';
    import { mapGetters } from 'vuex';
	import Modal from './modal';

	export default {
	  name: 'Header',
	  data () {
		return {
          drawer: null,
          menu: menu,
          currentMenuItem: '',
          clickStatus: [],
          showButton: true,
          showDashboard: true,
          showWidget:true,
          logo: window.location.protocol + process.env.MYSPEC_ENDPOINT + 'profile.php?t=/' + this.$store.getters.objAuthorize.myspec_url + '&p=' + this.$store.getters.objAuthorize.header_logo_img
		}
	  },
      methods: {
	    fncCanSeeLite() {

	      return true;

      },
        fncGoSummary() {
          var modalDetails = { title: 'Summary Reporting', component: 'modal-summary-reporting', mstate: true, params: {} };
          this.$store.commit({
            type: 'setModal',
            details: modalDetails
          });
        },
        fncCheckSettings(){
          if( this.objAuthorize.privileges != null && this.objAuthorize.privileges.indexOf('CAN_VIEW_SETTINGS') != -1 ) {
            return true;
          }
          return false;
      },
        fncGetLogo() {
          return this.logo;
        },
		fncGoQuoteReports() {
			router.replace('/reports/quote-reports');
		  },
        fncGoQuoteReportsLite() {
          router.replace('/reports/quote-reports-lite');
        },
        fncGoWidgets() {
          router.replace('/dashboard/landing');
        },
        fncGoDashboard() {
          if (this.objAuthorize.privileges.indexOf('VIEW_WIDGETS') != -1 ){
            router.replace('/dashboard/landing');
          }
          else if(this.objAuthorize.privileges.indexOf('VIEW_QUOTES') != -1){
            router.replace('/reports/quote-reports');
          }
          else
            router.replace('/');
        },
		toggleDrawer() {
          this.drawer = !this.drawer;
		},
    fncShowInstallations() {
      var modalDetails = { title: 'Installations', component: 'modal-installations', mstate: true };
      this.$store.commit({
        type: 'setModal',
        details: modalDetails
      });
      this.drawer = false;
    },
		fncShowSettings () {
			var modalDetails = { title: 'General Settings', component: 'modal-general-settings', mstate: true };
			this.$store.commit({
				type: 'setModal',
				details: modalDetails
			});
          this.drawer = false;
		},
        fncShowStock () {
          var modalDetails = { title: 'Stock Availability', component: 'modal-stock', mstate: true };
          this.$store.commit({
            type: 'setModal',
            details: modalDetails
          });
          this.drawer = false;
        },
        fncShowSetup () {
          var modalDetails = { title: 'New MyOrder Setup', component: 'modal-setup', mstate: true };
          this.$store.commit({
            type: 'setModal',
            details: modalDetails
          });
          this.drawer = false;
        },
		fncLogout() {
			this.$store.dispatch('fncLogout');
        },
        showNavChildren(itemId, itemLink, index) {
          if( this.currentMenuItem == itemId  ) {
            for (let i = 0; i < this.clickStatus.length; i++) {
              for (let prop in this.clickStatus[i]) {
                Vue.set(this.clickStatus[i], prop, false);
              }
            }
            this.currentMenuItem = '';
          } else {
            if (itemLink !== '#') {
              router.replace(itemLink);
            } else {
              for (let i = 0; i < this.clickStatus.length; i++) {
                for (let prop in this.clickStatus[i]) {
                  Vue.set(this.clickStatus[i], prop, false);
                }
              }
              Vue.set(this.clickStatus[index], itemId, true);
              this.currentMenuItem = itemId;
            }
          }

        },
        showFirstLetter(title) {
          if (title.charAt(0) != '[' ) {
            return title.charAt(0);
          } else {
            return title.charAt(1);
          }
        },
        fncGoPage(routerLink) {
          router.replace(routerLink);
          this.drawer = false;
        },
        fncClearStorage() {
          localStorage.clear();
          window.localStorage.clear();
          var snackDetails = { color: 'success', message: 'All filters have been cleared', display: true };
          this.$store.commit('setSnack', snackDetails);
        },
        fncSubMenuTitle(menuTitle) {

          switch (menuTitle) {
            case '[REPS]':
              return this.objAuthorize.manu_user_alias;
            case '[CUSTOMERS]':
              return this.objAuthorize.customer_user_alias;
            case '[SPECIFIER]':
              return this.objAuthorize.specifier_user_alias;
            case '[PUBLIC]':
              return this.objAuthorize.public_user_alias;
            case '[VENDOR]':
              return 'Vendor Users';
            default:
              return menuTitle;
          }
        }
	  },
	  components: {
		Modal
      },
	  computed: {
      isActiveButton() {
        return this.$route.path === '/reports/quote-reports';
      },
      isActiveButtonLite() {
        return this.$route.path === '/reports/quote-reports-lite';
      },
      ShowWidgets() {
        const allowedPaths = [
          '/dashboard/landing',
          '/dashboard/conversion',
          '/dashboard/conversion-py',
          '/dashboard/escalation'
        ];

        return allowedPaths.includes(this.$route.path);
      },
		userFullname() {
			return this.$store.getters.objAuthorize.name + ' ' + this.$store.getters.objAuthorize.surname;
		},
		userManufacturer() {
			return this.$store.getters.objAuthorize.manufacturer_name;
		},
		objAuthorize() {
			return this.$store.getters.objAuthorize;
		},
		globalSnackColor() {
			return this.$store.getters.globalSnackColor;
		},
		globalSnackDisplay() {
			return this.$store.getters.globalSnackDisplay;
		},
		globalSnackMessage() {
			return this.$store.getters.globalSnackMessage;
		},
		spineToken() {
			return this.$store.getters.spineToken;
		},
		jwtAuth() {
			return this.$store.getters.jwtAuth;
        },
        objAuthorize() {
          return this.$store.getters.objAuthorize;
        }
	  },
	  beforeCreate() {
		var snackDetails = {color: 'success', message: '', display: false};
		this.$store.commit('setSnack', snackDetails);
      },
    created() {
      for (let i = 0; i < menu.length; i++) {
        var sub_item = { [menu[i].id]: false }
        this.clickStatus.push(sub_item);
      }
      if (
        this.objAuthorize &&
        this.objAuthorize.type !== undefined &&
        this.objAuthorize.type === 6 && Object.keys(this.$route.query).length === 0
      ) {
        this.$router.replace('/reports/sales-order-reports');
      }

      if (this.$route.path == '/reports/quote-reports' ) {
        console.log('report')
        this.showButton = true;
        this.showWidget = false;
      }

      if (this.$route.path == '/' ) {
        this.showDashboard = false;
      }
      if (this.$route.path == '/dashboard/landing' ) {
        console.log('Widgets')
        this.showWidget = true;
        this.showButton = false;
        this.$forceUpdate()
      }

    }
	};
</script>

<style scoped>
	/*@import '../shared/assets/css/shared.css'*/
</style>
